import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  DwConfigService,
  DwConfigServiceToken,
  DwEventService,
  DwOrmDataService,
  DwSecurityTopics
} from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { AppMetaData } from '../../../meta-data/app-meta-data.service';
import { AssignmentRecipientOptions } from '../models/assignment-recipient-options.model';

@Injectable({ providedIn: 'root' })
export class AssignmentRecipientOptionsService {
  private readonly apiUrl: string;
  private options$: Observable<AssignmentRecipientOptions>;

  constructor(
    @Inject(DwConfigServiceToken) configService: DwConfigService,
    private http: HttpClient,
    private dwEventService: DwEventService
  ) {
    this.apiUrl = `${configService.coreConfig.apiRoot}/aviator-online/students/assignments/recipient-options`;

    [
      AppMetaData.Student.ItemDetail.itemName,
      AppMetaData.StudentCourse.ItemDetail.itemName,
      AppMetaData.InstructorStudent.ItemDetail.itemName,
      AppMetaData.FlightSchoolGroup.ItemDetail.itemName,
      AppMetaData.FlightSchoolGroupStudent.ItemDetail.itemName
    ].forEach(itemName => this.dwEventService
      .getEventData(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(itemName))
      .subscribe(() => this.clear()));

    this.dwEventService.getEventData(DwSecurityTopics.SECURITY_CHANGED)
      .subscribe(() => this.clear());
  }

  getOptions(): Observable<AssignmentRecipientOptions> {
    if (!this.options$) {
      this.options$ = this.http.get<AssignmentRecipientOptions>(this.apiUrl)
        .pipe(shareReplay(1));
    }

    return this.options$;
  }

  clear(): void {
    this.options$ = null;
  }
}
